import { render, staticRenderFns } from "./PaymentMethodInputs.vue?vue&type=template&id=d853a438&"
import script from "./PaymentMethodInputs.vue?vue&type=script&lang=ts&"
export * from "./PaymentMethodInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports